import { Tabs } from "@/components/ui/tabs";
import type { GalleryMedia } from "@/lib/galleryQuery";

export function MediaFilterTabs({ value, onChange }: { value: GalleryMedia; onChange: (value: GalleryMedia) => void }) {
  return <div role="group" aria-label="Gallery media filter" className="min-w-0">
    <span className="mb-1 block text-[10px] font-semibold text-studio-muted">Gallery</span>
    <Tabs<GalleryMedia> tabs={[{value:"all",label:"All"},{value:"image",label:"Image"},{value:"video",label:"Video"},{value:"audio",label:"Audio"}]} value={value} onChange={onChange} fullWidth />
  </div>;
}
